import React from 'react';

/** Segmented, frosted pill tab bar. Ported from D:\campaigning-system\src\components\ui\Tabs.tsx. */
export function Tabs({ items, value, onChange, size = 'md', className = '' }) {
  const pad = size === 'sm' ? 'px-3 py-1.5 text-[13px]' : 'px-3.5 py-2 text-sm';
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-xl border border-cos-line-subtle bg-white/55 p-1 backdrop-blur-sm ${className}`}
      role="tablist"
    >
      {items.map((item) => {
        const active = item.key === value;
        return (
          <button
            key={item.key}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.key)}
            className={[
              'inline-flex items-center gap-2 whitespace-nowrap rounded-lg font-medium transition-all duration-200',
              pad,
              active ? 'bg-white text-cos-ink shadow-cos-glass-sm ring-1 ring-cos-teal/15' : 'text-cos-ink-secondary hover:text-cos-ink',
            ].join(' ')}
          >
            {item.label}
            {item.count !== undefined && (
              <span
                className={[
                  'mono rounded-full px-1.5 py-0.5 text-2xs font-semibold',
                  active ? 'bg-cos-teal-faint text-cos-teal-deep' : 'bg-[rgba(70,80,72,0.08)] text-cos-ink-muted',
                ].join(' ')}
              >
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
